import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { getSocket } from './socketManager';
import { taskActions, projectActions, userActions } from '../store';

export const useSocketEvents = () => {
  const dispatch = useDispatch();
  const debounceRef = useRef({});

  useEffect(() => {
    const socket = getSocket();
    if (!socket) return;

    const handleDataChange = (event) => {
      const { entity, action } = event;
      const key = entity;

      // Debounce: don't re-fetch same entity more than once per 500ms
      if (debounceRef.current[key]) {
        clearTimeout(debounceRef.current[key]);
      }
      debounceRef.current[key] = setTimeout(() => {
        switch (entity) {
          case 'task':
            dispatch(taskActions.getTasks({}));
            break;
          case 'project':
            dispatch(projectActions.getProjects());
            break;
          case 'user':
            dispatch(userActions.getUsers());
            break;
          case 'labor':
            // Labor changes should refresh tasks too (for work item counts on cards)
            dispatch(taskActions.getTasks({}));
            break;
          case 'tag':
          case 'comment':
            // These are scoped — the relevant page will re-fetch when opened
            break;
          default:
            break;
        }
        delete debounceRef.current[key];
      }, 500);
    };

    socket.on('data-change', handleDataChange);

    return () => {
      socket.off('data-change', handleDataChange);
      // Clear any pending debounce timers
      Object.values(debounceRef.current).forEach(clearTimeout);
    };
  }, [dispatch]);
};
